import {
  INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY,
  INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING,
  INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR,
  INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING,
  INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS,
  INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS,
  INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION,
  INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION,
  INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS,

} from './constants';
import {
  fetchAllShipperBidsInquiry,
} from 'src/api/inquiry';

export const setFilter = body => async (dispatch, getState) => {
  dispatch(
    {
      type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS,
      data: body,
    });
  dispatch({
    type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION,
  });
};
export const applyFilter = inquiryId => async (dispatch, getState) => {
  dispatch(
    {
      type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS,
    });
  dispatch({
    type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION,
  });
  dispatch(getBidsEnquiry(inquiryId));
};

export const allBidsInquiryPagination = (val, inquiryId) => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION,
    data: val,
  });
  getBidsEnquiry(inquiryId);
};

export const getBidsEnquiry = inquiryid => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING,
  });

  const appliedFilters = getState().inquiryShipperBidsReducer.appliedFilters;
  const pagination = getState().inquiryShipperBidsReducer.pagination;
  const inquiryId = inquiryid;
  const sortBy = appliedFilters.sortBy ? appliedFilters.sortBy : 'rank';
  const carrierList = appliedFilters.shippingLineList ? appliedFilters.shippingLineList : [];
  const ffIdList = appliedFilters.ffIdList ? appliedFilters.ffIdList : [];
  const ffGroupIdList = appliedFilters.ffGroupIdList ? appliedFilters.ffGroupIdList : [];
  const currentPageNumber = pagination.currentPageNumber ? pagination.currentPageNumber : 1;
  const descendingOrder = appliedFilters.descendingOrder;
  const bidIdList = appliedFilters.bidIdList;
  const bidStatusList = appliedFilters.bidStatusList || ['ACTIVE'];
  const bidsTypeList = appliedFilters.bidsTypeList || [];
  const showPreSelectedBids = appliedFilters.showPreSelectedBids;
  const body = {
    inquiryId,
    bidIdList,
    sortBy,
    carrierList,
    ffIdList,
    ffGroupIdList,
    currentPageNumber,
    descendingOrder,
    bidStatusList,
    bidsTypeList,
    showPreSelectedBids,
  };
  const response: any = await fetchAllShipperBidsInquiry(body);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR,
      errorMessage: response.errorMessage,
    });
  }
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING,
  });
};

export const resetFilters = inquiryId => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS,
  });
  dispatch({
    type: INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION,
  });
  dispatch(getBidsEnquiry(inquiryId));
};

export const enableBidLoading = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING,
  });
};

export const disableBidLoading = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING,
  });
};